// @ts-nocheck
// Inspired by: https://www.netlify.com/blog/2020/12/05/building-a-custom-react-media-query-hook-for-more-responsive-apps/
import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  // Setting default state to null so SSR and client side receive the same value and doesn't cause hydration issue;
  // https://www.joshwcomeau.com/react/the-perils-of-rehydration/
  // https://nextjs.org/docs/messages/react-hydration-error#solution-1-using-useeffect-to-run-on-the-client-only
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    if (!window) return null;
    const media = window?.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = (): void => {
      setMatches(media.matches);
    };
    media.addEventListener('change', listener);
    return (): void => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}
